import { makeObservable } from 'mobx';
import StripesStore from './store-stripes';
import StripesProviderStore from './store-stripes-provider';
import UIStoreProvider from './store-ui-provider';

export class RootStore {
  stripesStore: StripesStore;
  stripesProviderStore: StripesProviderStore;
  uiStoreProvider: UIStoreProvider;

  constructor() {
    this.stripesStore = new StripesStore();
    this.stripesProviderStore = new StripesProviderStore();
    this.uiStoreProvider = new UIStoreProvider(this);
    makeObservable(this, {});
  }
}

export const rootStore = new RootStore();
